// composables/pollingController.ts
import { ref } from 'vue'
import { usePollingFlight } from '@/composables/usePollingFlight'
import store from '@/store/BookingStore'
import { BookingFunnelService } from '@/service/BookingFunnelService/BookingFunnelService';
import { FamilyId, LuggageDetails, Option, Transport } from '../../../requests-module';
import { FlightService } from '@/service/FlightService/FlightService';

interface PollingApiResponse {
  success: boolean
  flightDetails: Transport | null
  luggageDetails: LuggageDetails[] | null
}

const pollingStarted = ref(false)

export function startGlobalPollingFlight(boRefrence: string) {
  if (pollingStarted.value) return
  pollingStarted.value = true

  const { stopPolling } = usePollingFlight<PollingApiResponse>(
    boRefrence,
    10 * 1000, // 10 seconds interval
    (data) => !data.success, // continue polling if success === false
    async (data) => {
      pollingStarted.value = false
      // First we update the booking with the new flight details
      const flight: Option = store.getters.getBooking.options.find(option => option.familyId === FamilyId.FLIGHT)
      if (flight) {
        flight.details = data.flightDetails;
        flight.cache = false;
      }
      // then we save the option flight
      const newBooking = await BookingFunnelService.updateServices([flight], 'service');
      if ('error' in newBooking) {
        console.error(newBooking.error);
        return;
      }
      // then we save the luggage details for the flight
      store.commit('setLuggageDetails', data.luggageDetails);

      // Handling the session status (in case of long latency)
      const updatedFlight = newBooking.options.find(option => option.familyId === FamilyId.FLIGHT)
      if ((updatedFlight.details as Transport).sessionStatus === 'Renew') {
        startGlobalPollingFlight(store.getters.getBooking.boReference);
      }
    }
  )

  return stopPolling
}
